import { render, staticRenderFns } from "./xeCompareCard.vue?vue&type=template&id=4423ae7c&scoped=true"
import script from "./xeCompareCard.vue?vue&type=script&lang=js"
export * from "./xeCompareCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423ae7c",
  null
  
)

export default component.exports